module.exports = __webpack_public_path__ + "static/media/foto3.cddf029e.png";